module.exports = __webpack_public_path__ + "static/img/woman_stu.3c54ba59.png";